<template>
	<div>
		<div
			class="d-flex justify-content-between align-items-center col-lg-4"
			v-if="checkUser"
		>
			<v-select
				auto-select-first
				:items="institutes"
				v-model="currentIns"
				@change="changeInstitute"
				item-text="name"
				item-value="id"
				:label="$t('instituteName')"
				color="green"
				item-color="green"
			>
			</v-select>
		</div>
		<RescheduleRequestsFilter
			@resetFilter="resetRescheduleRequestsFilter"
			@filterData="filterRescheduleRequests"
		/>
		<v-tabs
			class="mt-8"
			v-model="tab"
			fixed-tabs
			dark
			background-color="#72a0e3"
			icons-and-text
			centered
		>
			<v-tab href="#rescheduleRequests" active-class="active-tab">
				{{ $t("rescheduleRequests") }}
				<v-icon>mdi-calendar-today</v-icon>
			</v-tab>
			<v-tab href="#classes" active-class="active-tab">
				{{ $t("classes") }}
				<v-icon>mdi-google-classroom</v-icon>
			</v-tab>
			<v-tabs-items v-model="tab">
				<v-tab-item value="rescheduleRequests" eager>
					<div class="mb-12 mt-8">
						<h3 class="student-subaccount-box--title mb-6">
							{{ $t("rescheduleRequests") }}
						</h3>
						<v-data-table
							:headers="requestRescheduleHeadersTitles"
							:items="filteredSessions"
							item-key="id"
							class="elevation-1"
							:items-per-page="tableOptions.itemPerPage"
							:footer-props="tableFooterOptions"
							:no-data-text="`${$t('noResultsHere')}`"
						>
							<template v-slot:item.actions="{ item }">
								<v-tooltip top>
									<template v-slot:activator="{ on, attrs }">
										<v-icon
											color="blue lighten-2"
											class="mx-1"
											dense
											v-bind="attrs"
											v-on="on"
											@click.stop="showAcceptConfirmationDialog(item)"
										>
											mdi-thumb-up
										</v-icon>
									</template>
									<span>{{ $t("acceptReschedule") }}</span>
								</v-tooltip>
								<v-tooltip top>
									<template v-slot:activator="{ on, attrs }">
										<v-icon
											color="red lighten-2"
											class="mx-1"
											dense
											v-bind="attrs"
											v-on="on"
											@click.stop="showRefuseConfirmationDialog(item)"
										>
											mdi-thumb-down
										</v-icon>
									</template>
									<span>{{ $t("refuseReschedule") }}</span>
								</v-tooltip>
							</template>
						</v-data-table>
					</div>
				</v-tab-item>
				<v-tab-item value="classes">
					<div class="mb-12 mt-8">
						<h3 class="student-subaccount-box--title mb-6">
							{{ $t("classes") }}
						</h3>
					</div>
				</v-tab-item>
			</v-tabs-items>
		</v-tabs>

		<ConfirmationModal
			:dialog="acceptConfirmationDialog"
			@closeDialog="handleAcceptConfirmationDialog"
			:data="acceptConfirmationData"
			:text="
				$t('ConfirmationModal.areYouSureYouWantToAcceptTheRescheduleRequest')
			"
		/>
		<ConfirmationModal
			:dialog="refuseConfirmationDialog"
			@closeDialog="handleRefuseConfirmationDialog"
			:data="refuseConfirmationData"
			:text="
				$t('ConfirmationModal.areYouSureYouWantToRefuseTheRescheduleRequest')
			"
		/>
	</div>
</template>

<script>
import moment from "moment-timezone";
import GlobalMixin from "@/GlobalMixin.js";
import RescheduleRequestsFilter from "./RescheduleRequestsFilter.vue";
import ConfirmationModal from "../Modals/ConfirmationModal.vue";

export default {
	name: "rescheduleRequests",
	components: { RescheduleRequestsFilter, ConfirmationModal },
	mixins: [GlobalMixin],
	data() {
		return {
			institutes: [],
			currentIns: null,
			userObj: JSON.parse(localStorage.getItem("vuex")),
			pendingSessions: [],
			filteredSessions: [],
			// totalRequests: null,

			tab: null,

			tableFooterOptions: {
				"items-per-page-options": [10, 20, 30, 40, 50, 100],
				"show-current-page": true,
				showFirstLastPage: true,
				firstIcon: "mdi-arrow-collapse-left",
				lastIcon: "mdi-arrow-collapse-right",
			},
			tableOptions: {
				page: 1,
				offset: this.$route.query.offset ? +this.$route.query.offset : 0,
				itemPerPage: this.$route.query.limit ? +this.$route.query.limit : 10,
			},

			acceptConfirmationDialog: false,
			refuseConfirmationDialog: false,
			acceptConfirmationData: null,
			refuseConfirmationData: null,
		};
	},
	mounted() {
		// Get query params for the URL
		this.currentIns = +this.$route.query.ins
			? +this.$route.query.ins
			: this.getInstituteId;
		// Call institutes in case of super admin
		if (this.userObj.auth.user.user.user_type === "operator") {
			this.getAllInstitutes();
		}

		this.getPendingSessions();
	},
	methods: {
		/**
		 * Get all Institutes from the API
		 */
		getAllInstitutes() {
			this.axios(`${process.env.VUE_APP_APIEndPoint}institutes/`, this.headers)
				.then(
					res =>
						(this.institutes = res.data.data.sort((a, b) =>
							a?.name.toLowerCase() > b?.name.toLowerCase() ? 1 : -1
						))
				)
				.catch(err => console.error(err));
		},
		/**
		 * Change Institute
		 */
		changeInstitute() {
			if (!this.currentIns) this.currentIns = 1;
			history.pushState(
				{},
				null,
				`${this.$route.path}?ins=${this.currentIns}&offset=${this.tableOptions.offset}#${this.tab}`
			);

			this.getPendingSessions();
		},
		/**
		 * FIlter reschedule requests
		 * @param {*} filterObj
		 */
		async filterRescheduleRequests({
			studentName,
			tutorName,
			startDate,
			requestedDate,
		}) {
			this.filteredSessions = this.pendingSessions;

			if (studentName) {
				this.filteredSessions = this.filteredSessions.filter(session =>
					session.requester.full_name
						.toLowerCase()
						.includes(studentName.toLowerCase())
				);
			}
			if (tutorName) {
				this.filteredSessions = this.filteredSessions.filter(session =>
					session.requestee.full_name
						.toLowerCase()
						.includes(tutorName.toLowerCase())
				);
			}
			if (startDate) {
				this.filteredSessions = this.filteredSessions.filter(
					session =>
						session.start_date == moment(startDate).format("DD/MM/YYYY")
				);
			}
			if (requestedDate) {
				this.filteredSessions = this.filteredSessions.filter(
					session =>
						session.requested_date == moment(requestedDate).format("DD/MM/YYYY")
				);
			}
		},
		/**
		 * Reset filter
		 */
		resetRescheduleRequestsFilter() {
			this.getPendingSessions();
		},
		/**
		 * Get pending sessions
		 */
		getPendingSessions() {
			const body = {
				institute: this.currentIns,
				status: [1],
				offset: this.$route.query.offset ? +this.$route.query.offset : 0,
				limit: 100,
			};

			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}reserve/session/reschedule/list/`,
					body,
					this.headers
				)
				.then(res => {
					this.pendingSessions = res.data.data
						.filter(
							session =>
								moment(session.old_scheduled_utc_start_date_time) >
								moment(new Date())
						)
						.map(session => {
							return {
								...session,
								start_date: moment
									.utc(session.old_scheduled_utc_start_date_time)
									.local()
									.format("DD/MM/YYYY"),
								start_time: moment
									.utc(session.old_scheduled_utc_start_date_time)
									.local()
									.format("HH:mm:ss"),
								requested_date: moment
									.utc(session.requested_scheduled_utc_start_date_time)
									.local()
									.format("DD/MM/YYYY"),
								requested_time: moment
									.utc(session.requested_scheduled_utc_start_date_time)
									.local()
									.format("HH:mm:ss"),
							};
						});

					this.filteredSessions = this.pendingSessions;
					// this.totalRequests = res.data.pagination_data.count;
				})
				.catch(err => this.formatErrors(err));
		},
		// updateRequests(options) {
		// 	this.tableOptions.sortBy = options.sortBy || [];
		// 	this.tableOptions.sortDesc = options.sortDesc || [];
		// 	if (!this.currentIns) this.currentIns = this.getInstituteId;
		// 	// Get neccessary values for table (itemPerPage, page, offset)
		// 	this.tableOptions.offset = options.itemsPerPage * (options.page - 1);
		// 	this.tableOptions.itemPerPage = options.itemsPerPage;
		// 	this.tableOptions.page = this.tableOptions.offset
		// 		? this.tableOptions.offset / this.tableOptions.itemPerPage + 1
		// 		: 1;
		// 	// Change URL without reloading the page
		// 	history.pushState(
		// 		{},
		// 		null,
		// 		`${this.$route.path}?ins=${this.currentIns}&limit=${this.tableOptions.itemPerPage}&offset=${this.tableOptions.offset}#${this.tab}`
		// 	);

		// 	this.getPendingSessions();
		// },
		async updateRescheduleStatus(item, status) {
			const body = {
				tutor: item.requestee.id,
				institute: this.currentIns,
				requested_slot: {
					start_date_time: moment
						.utc(item.requested_scheduled_utc_start_date_time)
						.local()
						.format("YYYY-MM-DD HH:mm:ss"),
					end_date_time: moment
						.utc(item.requested_scheduled_utc_end_date_time)
						.local()
						.format("YYYY-MM-DD HH:mm:ss"),
				},
				status: status,
			};

			await this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}reserve/session/reschedule/update-status/`,
					body,
					this.headers
				)
				.then(res => this.showAlert(res.data.data.message, "success"))
				.catch(err => this.formatErrors(err));

			await this.getPendingSessions();
		},
		// acceptReschedule(item) {
		// 	this.updateRescheduleStatus(item, 2);
		// },
		// refuseReschedule(item) {
		// 	this.updateRescheduleStatus(item, 3);
		// },
		showAcceptConfirmationDialog(item) {
			this.acceptConfirmationData = item;
			this.acceptConfirmationDialog = true;
		},
		handleAcceptConfirmationDialog(item) {
			if (!item) return (this.acceptConfirmationDialog = false);
			this.updateRescheduleStatus(item, 2);
			this.acceptConfirmationData = null;
			this.acceptConfirmationDialog = false;
		},
		showRefuseConfirmationDialog(item) {
			this.refuseConfirmationData = item;
			this.refuseConfirmationDialog = true;
		},
		handleRefuseConfirmationDialog(item) {
			if (!item) return (this.refuseConfirmationDialog = false);
			this.updateRescheduleStatus(item, 3);
			this.refuseConfirmationData = null;
			this.refuseConfirmationDialog = false;
		},
	},
	computed: {
		/**
		 * Check if user is super admin or not
		 */
		checkUser() {
			return this.userObj.auth.user.user.user_type === "operator";
		},
		/**
		 * @returns institute id depends on role of the user
		 */
		getInstituteId() {
			return this.userObj.auth.user.user.user_type === "operator"
				? 1
				: +this.userObj.auth.user.user.username.slice("").at(-1);
		},
		requestRescheduleHeadersTitles() {
			return [
				{
					text: this.$t("studentName"),
					value: "requester.full_name",
					sortable: false,
				},
				{
					text: this.$t("tutorName"),
					value: "requestee.full_name",
					sortable: false,
				},
				{ text: this.$t("Start_Date"), value: "start_date", sortable: false },
				{ text: this.$t("Start_Time"), value: "start_time", sortable: false },
				{
					text: this.$t("requestedDate"),
					value: "requested_date",
					sortable: false,
				},
				{
					text: this.$t("requestedTime"),
					value: "requested_time",
					sortable: false,
				},
				{ text: this.$t("Action"), value: "actions", sortable: false },
			];
		},
	},
	watch: {
		/**
		 * Change tab property based on active tab
		 * @param newVal number
		 */
		tab(newVal) {
			this.tableOptions = {
				page: 1,
				offset: 0,
				itemsPerPage: 10,
				sortBy: [],
				sortDesc: [],
			};
			// Change URL without reloading the page
			history.pushState(
				{},
				null,
				`${this.$route.path}?ins=${this.currentIns}&limit=${this.tableOptions.itemsPerPage}&offset=${this.tableOptions.offset}#${newVal}`
			);
		},
	},
};
</script>

<style lang="scss" scoped>
.table-box {
	min-height: 730px;
}

.active-tab {
	background: #1976d2;
}

::v-deep .v-text-field__details {
	display: none;
}

::v-deep .v-input__slot {
	margin: 0;
}
</style>
